<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { required, email } from '@validations';

export default {
  components: {
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        tipopedidoid: '',
        tipopedidodescricao: '',
        tipopedidotriangular: '',
      }),
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
      require: false,
    },
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    async validateForm(bvModalEvent) {
      // Em modo edição o modal é apenas visualização ("Fechar"): só fecha.
      if (this.isEdit) return;

      const isValid = await this.$refs.refFormData.validate();
      if (!isValid) {
        if (bvModalEvent) bvModalEvent.preventDefault();
        return;
      }
      this.$emit('ok', this.dataForm);
    },
  },
};
</script>

<template>
  <b-modal
      no-close-on-backdrop
      no-close-on-esc
      size="md"
      :id="idModal"
      :title="titleModal"
      :ok-disabled="!isEdit && (!dataForm.tipopedidoid || dataForm.tipopedidodescricao === '')"
      :ok-title="labelBtnOk"
      ok-variant="success"
      cancel-variant="secondary"
      body-bg-variant="light"
      cancel-title="Cancelar"
      @ok="validateForm"
      @cancel="$emit('cancel')"
      @close="$emit('cancel')"
  >
    <validation-observer ref="refFormData">
      <b-form @submit.prevent>
        <b-row>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Código"
                label-for="tipopedidoid"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Código"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.tipopedidoid"
                    id="tipopedidoid"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite o código"
                    :disabled="isEdit"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Descrição"
                label-for="tipopedidodescricao"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.tipopedidodescricao"
                    id="tipopedidodescricao"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite a descrição"
                    :disabled="isEdit"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Triangular"
                label-for="tipopedidotriangular"
            >
              <b-form-checkbox
                  v-model="dataForm.tipopedidotriangular"
                  id="tipopedidotriangular"
                  :disabled="isEdit"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
